import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NButton, NFormItem, NInputNumber, NForm, NCard, NTable, NThead, NTbody, NTh, NTr, NTd } from 'naive-ui'
import EmbedCode from "@/components/embed";


createApp({
    components: { NButton, NFormItem, NInputNumber, NForm, NCard, NTable, NThead, NTbody, NTh, NTr, NTd, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            reps: 1,
            weight: 30,
            percentage: {
                1: 100,
                2: 94,
                3: 91,
                4: 88,
                5: 86,
                6: 83,
                7: 81,
                8: 79,
                9: 77,
                10: 75,
            }
        }
    },
    methods: {
        calc1RP(weight, reps) {
            if (reps === 1) {
                return weight;
            }
            return Math.round(weight * (1 + (reps/29.4)));
        }
    },
    computed: {
        result() {
            const data = [];
            const oneRP = this.calc1RP(this.weight, this.reps);

            for (let reps in this.percentage) {
                data.push([
                    reps,
                    oneRP * this.percentage[reps] / 100,
                    this.percentage[reps] + '%',
                ]);
            }

            return data;
        }
    }
}).mount('#app')
